import MPCList, { MPCListProps, MPCListRef } from '@mpc/common/src/features/MPCList';
import React, { useMemo } from 'react';
import { BIDDING_TAB_KEY, DEMAND_TAB_KEY, FIRST_LEVEL_ENUM, LIST_CONF, PREPAYMENT_TAB_KEY } from './utils';
import TopTabs from './TopTabs';
import { ajax, showAlert } from 'utils';
import {
  enums,
  outBiddingWorkbenchesList,
  outsourceCommonFilterOptions,
  outsourceMyWorkspaceGetDemandTodoList,
  outsourceMyWorkspaceGetPrepaymentSettledUploadList,
  outsourceMyWorkspaceGetPrepaymentAllList,
} from 'services/api';
import { useMemoizedFn } from 'ahooks';
import _ from 'lodash';
import { Badge } from '@bedrock/components';
import { getKey, mpc_table_row_text_grey } from '@mpc/common/src/features/MPCList/utils';
import './index.less';
import moment from 'moment';

export default function OutWorkbenchPortal(props: any) {
  const { menuCount, getMenuCount, childMenus, account } = props;
  const pathArr = props?.location?.pathname?.split('/') || [];
  const firstLevel = pathArr[2] as keyof typeof LIST_CONF;
  const secondLevel = pathArr[3] as
    | keyof (typeof LIST_CONF)[FIRST_LEVEL_ENUM.outNormalPurchase]
    | keyof (typeof LIST_CONF)[FIRST_LEVEL_ENUM.outBiddingPurchase];
  const listRef = React.useRef<MPCListRef>();
  /** 存储额外信息，目前用于存储各tab是我列排序信息 */
  const extRef = React.useRef<any>({});

  const refreshTable = useMemoizedFn(() => {
    listRef?.current?.tableRef.current?.queryCurrentPage?.();
    getMenuCount?.();
  });


  const showPrePayment = useMemo(() => {
    return account?.menus
      ?.find((menu: any) => menu?.key === 'outWorkbenchPortal')
      ?.children?.some((child: any) => child?.key === FIRST_LEVEL_ENUM.outPrepayment);
  }, [account]);


  /**
   * tab切换处理
   * @param key 菜单tabkey
   * @param level 菜单tab级别 默认 1
   * @returns
   */
  const handleTabsChange = (key: string, level: number = 1) => {
    const defaultSecTabKey = {
      [FIRST_LEVEL_ENUM.outNormalPurchase]: DEMAND_TAB_KEY.pendingQuote,
      [FIRST_LEVEL_ENUM.outBiddingPurchase]: BIDDING_TAB_KEY.toDoBidding,
      [FIRST_LEVEL_ENUM.outPrepayment]: PREPAYMENT_TAB_KEY.prepaymentUpload,
    };
    if (level === 1) {
      pathArr[level + 1] = key;
      pathArr[level + 2] = defaultSecTabKey[key as keyof typeof defaultSecTabKey];
    } else {
      pathArr[level + 1] = key;
    }
    getMenuCount?.();
    props?.history?.push(pathArr.join('/') + props.location?.search);
  };

  const handleDealChange = (body: { finished: boolean; id: string }) => {
    ajax({
      url: 'outsource/v2/demands/processed',
      method: 'POST',
      body,
    }).then((res: any) => {
      showAlert({
        type: 'success',
        message: res.res_msg,
      });
      listRef.current?.refreshTable();
    });
  };

  // @ts-ignore
  const currListConf = LIST_CONF?.[firstLevel]?.[secondLevel];

  const filterOptions = currListConf?.filterOptions || {};

  const customColumnsConf = currListConf?.customColumnsConf?.({ handleDealChange, secondLevel });

  // const items = firstLevel === FIRST_LEVEL_ENUM.outBiddingPurchase ? biddingTabItems : demandTabItems;
  const items =
    childMenus?.map?.((menu: { name: any; key: string }) => {
      const badge = menuCount?.find((countInfo: any) => countInfo.key === menu.key)?.count;
      return {
        ...menu,
        tab: (
          <div>
            {menu.name}
            <Badge count={badge} className="m-l-8" />
          </div>
        ),
      };
    }) || [];

  const fetchList: MPCListProps['fetchList'] = (params) => {
    if (firstLevel === FIRST_LEVEL_ENUM.outNormalPurchase) {
      const todo_type = _.snakeCase(secondLevel?.replace('Portal', '') || '').toUpperCase() as any;
      const { conditions } = params;
      return outsourceMyWorkspaceGetDemandTodoList({
        ...params,
        ...conditions,
        quote_deadline_range:
          conditions?.quote_deadline_range === null
            ? undefined
            : conditions?.quote_deadline_range?.map((item: any) => moment(item).format('YYYY-MM-DD HH:mm:ss')),
        limit: params.pageSize,
        todo_type,
        // state: (_.snakeCase('pendingQuote')).toUpperCase() as any,
      }).then((res: any) => {
        const list = res?.data?.list || [];
        return {
          data: {
            ...res?.data,
            list: list.map((item: any) => ({ ...item, id: item?.leaf_demand_id || item?.plan_demand_id })),
          },
        };
      });
    }
    if (firstLevel === FIRST_LEVEL_ENUM.outPrepayment) {
      const { conditions } = params;
      const sort_param = extRef.current?.[secondLevel];
      let fetchListApi = outsourceMyWorkspaceGetPrepaymentSettledUploadList;
      if (secondLevel && (secondLevel as string) === PREPAYMENT_TAB_KEY.allPrepayment) {
        fetchListApi = outsourceMyWorkspaceGetPrepaymentAllList;
      }
      const newConditions = {
        ...conditions,
        sort_param,
        status_list: conditions?.status_list,
      };
      return fetchListApi({
        ...params,
        ...newConditions,
        limit: params.pageSize,
      }).then((res: any) => {
        const list = res?.data?.list || [];
        return {
          data: {
            ...res?.data,
            list: list,
          },
        };
      });
    }
    const bidding_states_map = {
      [BIDDING_TAB_KEY.toDoBidding]: enums.BiddingProcessStageEnum.TO_DO_PROCESS,
      [BIDDING_TAB_KEY.doneBidding]: enums.BiddingProcessStageEnum.COMPLETED_PROCESS,
    };
    return outBiddingWorkbenchesList({
      ...params,
      size: params.pageSize,
      bidding_process_stage: bidding_states_map[secondLevel as BIDDING_TAB_KEY],
    });
  };

  const fetchFilterOptions: MPCListProps['fetchFilterOptions'] = () => {
    const params =
      firstLevel === FIRST_LEVEL_ENUM.outNormalPurchase
        ? {
            outsource_todo_type: _.snakeCase(secondLevel?.replace('Portal', '') || '').toUpperCase() as any,
          }
        : {};
    return outsourceCommonFilterOptions({
      ...params,
      keys: filterOptions?.filterKeys?.map((key: any) => getKey(key, 'optionKey')),
    });
  };

  const toolbarSearch =
    firstLevel === FIRST_LEVEL_ENUM.outPrepayment
      ? {
          placeholder: '请输入预付单号/来源单号/需求标题',
          id: 'search_text',
          style: {
            width: 280,
          },
        }
      : undefined;

  return (
    <>
      <MPCList
        warpperClassName="outWorkbenchPortal"
        group_type={firstLevel}
        menuKey={
          firstLevel === FIRST_LEVEL_ENUM.outNormalPurchase
            ? _.snakeCase(secondLevel?.replace('Portal', '') || '').toUpperCase()
            : undefined
        }
        HeaderPlace={
          <TopTabs
            activeKey={firstLevel}
            onChange={handleTabsChange}
            items={[
              {
                key: FIRST_LEVEL_ENUM.outNormalPurchase,
                name: '常规采购',
                badge: menuCount?.find((countInfo: any) => countInfo.key === FIRST_LEVEL_ENUM['outNormalPurchase'])
                  ?.count,
              },
              {
                key: FIRST_LEVEL_ENUM.outBiddingPurchase,
                name: '比选',
                badge: menuCount?.find((countInfo: any) => countInfo.key === FIRST_LEVEL_ENUM['outBiddingPurchase'])
                  ?.count,
              },
              showPrePayment && {
                key: FIRST_LEVEL_ENUM.outPrepayment,
                name: '预付单',
                badge: menuCount?.find((countInfo: any) => countInfo.key === FIRST_LEVEL_ENUM['outPrepayment'])?.count,
              },
            ].filter(Boolean)}
          />
        }
        filterOptions={filterOptions}
        fetchFilterOptions={fetchFilterOptions}
        customColumnsConf={customColumnsConf}
        fetchList={fetchList}
        // @ts-ignore
        ref={listRef}
        // @ts-ignore
        ProTablePlusProps={{
          key: firstLevel,
          onSortChange(dataIndex, sortOrder) {
            const sort_param = sortOrder ? { sort_field: dataIndex, is_asc: sortOrder === 'ascend' } : undefined;
            extRef.current = {
              ...extRef.current,
              [secondLevel]: sort_param,
            };
            refreshTable();
          },
          toolbar: {
            search: toolbarSearch,
            tabSize: 'medium',
            filterSetting: {
              defaultKeys: filterOptions?.filterKeys?.map((key: any) => getKey(key, 'searchKey')),
              disableAddButton: true,
              dataStore: {
                key: location.pathname + `_${firstLevel}_${secondLevel}_with-condition`,
                fromThe: 'localStorage',
                toThe: 'localStorage',
              },
            },
            tabs: {
              defaultActiveKey: secondLevel,
              onChange: (key) => handleTabsChange(key, 2),
              items,
            },
          },
          rowClassName: (r: any, i: number) => {
            if (
              firstLevel === FIRST_LEVEL_ENUM.outNormalPurchase &&
              ['REJECTED', 'NOT_QUOTED', 'CANCELED', 'PAYED', 'NOT_SELECTED'].includes(r.state || '')
            ) {
              return mpc_table_row_text_grey;
            }
            if (firstLevel === FIRST_LEVEL_ENUM.outPrepayment && ['ABANDONED', 'COMPLETED'].includes(r.status || '')) {
              return mpc_table_row_text_grey;
            }
            return '';
          },
        }}
      />
    </>
  );
}
